import React from 'react'

const PurchaseOrderReceiving = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Purchase Order Receiving</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Receiving Goods</li>
            <li className="breadcrumb-item active">Purchase Order Receiving</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Purchase Order Receiving</h5>
                <p>Purchase order receiving content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PurchaseOrderReceiving

